"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShift = void 0;
const nmr_processing_1 = require("nmr-processing");
function getShift(spectrum) {
    const shift = { x: 0, y: 0 };
    if (spectrum?.filters) {
        for (const filter of spectrum.filters) {
            if (filter.name === nmr_processing_1.Filters.shift2DX.id) {
                shift.x = filter?.flag ? filter.value.shift : 0;
            }
            if (filter.name === nmr_processing_1.Filters.shift2DY.id) {
                shift.y = filter?.flag ? filter.value.shift : 0;
            }
        }
    }
    return shift;
}
exports.getShift = getShift;
